export enum MercerEditableByType {
  AdminOnly = 'AdminOnly',
  AdminAndHr = 'AdminAndHr',
  Nobody = 'Nobody',
  All = 'All'
}
